<template>
  <div style="width: 100%">
    <template >
      <div class="tag">
        <div class="content">
          <Tag
            v-for="(item, index) in tag_list"
            color="primary"
            :key="index"
            v-show="item"
            >{{ item }}</Tag
          >
        </div>
        <Tooltip placement="left" v-if="tag_list.length > 2" transfer>
          <template>
            <Icon  type="ios-eye" />
          </template>
          <div slot="content">
            <div v-html="$util.listTag(tag_list.join(';'))"></div>
          </div>
        </Tooltip>
      </div>
    </template>
    <!-- <template v-else>
      <div>
        {{ tag }}
      </div>
    </template> -->
  </div>
</template>

<script>
export default {
  name: "TagList",
  props: {
    tag: { type: String | Array, default: "" },
    show_count: {
      type: Number,
      default: 2
    }
  },
  computed: {
    tag_list() {
      if (typeof this.tag === "string") {
        return this.tag.split(";");
      } else {
        return this.tag
      }
    },
    isTags() {
      if (typeof this.tag === "string") {
        if (this.tag.length == 0) {
          return false;
        } else {
          return this.tag.split(";").length > 0;
        }
      }
    }
  },
  methods:{

  }
};
</script>

<style scoped lang="less">
/deep/ .ivu-tooltip-inner {
  white-space: normal;
  word-break: keep-all;
  width: 100%;
}
/*/deep/ .ivu-tooltip{*/
/*  width: 100%;*/
/*}*/
/*/deep/ .ivu-tooltip-rel{*/
/*  width: 100%;*/
/*}*/
/deep/ .ivu-tag {
  min-width: 40px;
  text-align: center;
}
.tag {
  display: flex;
  align-items: center;
  // width: 100%;
  width: 100%;
  position: relative;

  .content {
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tagList.vue